import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme, Button, Spinner, Text } from "@fluentui/react-components";
import App from "./App";
import { initAuth, login } from "./auth";

const root = createRoot(document.getElementById("root"));

const render = (node) => root.render(<FluentProvider theme={webLightTheme}>{node}</FluentProvider>);

const centered = (children) => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ textAlign: "center", maxWidth: 420 }}>{children}</div>
  </div>
);

render(centered(<Spinner label="Loading…" />));

initAuth()
  .then(({ enabled, account }) => {
    if (enabled && !account) {
      render(
        centered(
          <>
            <h2 style={{ color: "#00833f" }}>Davey Signatures — Admin</h2>
            <Text block style={{ marginBottom: 16 }}>Sign in with your Davey account to manage signatures.</Text>
            <Button appearance="primary" onClick={() => login()}>Sign in</Button>
          </>
        )
      );
    } else {
      render(<App />);
    }
  })
  .catch((e) => {
    render(centered(<Text style={{ color: "#a80000" }}>Sign-in error: {String(e.message || e)}</Text>));
  });
